/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { firstValueFrom } from "rxjs";

import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { getIotnetGatewayHealth } from "../fn/iotnet/get-iotnet-gateway-health";
import { GetIotnetGatewayHealth$Params } from "../fn/iotnet/get-iotnet-gateway-health";
import { getIotnetGatewayTraffic } from "../fn/iotnet/get-iotnet-gateway-traffic";
import { GetIotnetGatewayTraffic$Params } from "../fn/iotnet/get-iotnet-gateway-traffic";
import { getIotnetGatewaysForCustomer } from "../fn/iotnet/get-iotnet-gateways-for-customer";
import { GetIotnetGatewaysForCustomer$Params } from "../fn/iotnet/get-iotnet-gateways-for-customer";
import { HealthRecord } from "../models/health-record";
import { IotnetGateway } from "../models/iotnet-gateway";
import { Traffic } from "../models/traffic";
import { StrictHttpResponse } from "../strict-http-response";

@Injectable({ providedIn: "root" })
export class IotnetService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getIotnetGatewaysForCustomer()` */
  static readonly GetIotnetGatewaysForCustomerPath = "/stats/customers/{customer_id}/iotnet-gateways";

  /**
   * Get Iotnet Gateways For Customer.
   *
   * Retrieve the IoTnet gateways belonging to a customer's codes plus public gateways.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIotnetGatewaysForCustomer()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewaysForCustomer$Response(
    params: GetIotnetGatewaysForCustomer$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Array<IotnetGateway>>> {
    const obs = getIotnetGatewaysForCustomer(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Iotnet Gateways For Customer.
   *
   * Retrieve the IoTnet gateways belonging to a customer's codes plus public gateways.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIotnetGatewaysForCustomer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewaysForCustomer(
    params: GetIotnetGatewaysForCustomer$Params,
    context?: HttpContext,
  ): Promise<Array<IotnetGateway>> {
    const resp = this.getIotnetGatewaysForCustomer$Response(params, context);
    return resp.then((r: StrictHttpResponse<Array<IotnetGateway>>): Array<IotnetGateway> => r.body);
  }

  /** Path part for operation `getIotnetGatewayTraffic()` */
  static readonly GetIotnetGatewayTrafficPath = "/stats/customers/{customer_id}/iotnet-gateways/{gateway_id}/traffic";

  /**
   * Get Iotnet Gateway Traffic.
   *
   * Retrieve traffic for a customer's IoTnet gateway.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIotnetGatewayTraffic()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewayTraffic$Response(
    params: GetIotnetGatewayTraffic$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<Traffic>> {
    const obs = getIotnetGatewayTraffic(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Iotnet Gateway Traffic.
   *
   * Retrieve traffic for a customer's IoTnet gateway.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIotnetGatewayTraffic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewayTraffic(params: GetIotnetGatewayTraffic$Params, context?: HttpContext): Promise<Traffic> {
    const resp = this.getIotnetGatewayTraffic$Response(params, context);
    return resp.then((r: StrictHttpResponse<Traffic>): Traffic => r.body);
  }

  /** Path part for operation `getIotnetGatewayHealth()` */
  static readonly GetIotnetGatewayHealthPath = "/stats/customers/{customer_id}/iotnet-gateways/{gateway_id}/health";

  /**
   * Get Iotnet Gateway Health.
   *
   * Retrieve the current status and packet rates for a customer's IoTnet gateway.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIotnetGatewayHealth()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewayHealth$Response(
    params: GetIotnetGatewayHealth$Params,
    context?: HttpContext,
  ): Promise<StrictHttpResponse<HealthRecord>> {
    const obs = getIotnetGatewayHealth(this.http, this.rootUrl, params, context);
    return firstValueFrom(obs);
  }

  /**
   * Get Iotnet Gateway Health.
   *
   * Retrieve the current status and packet rates for a customer's IoTnet gateway.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIotnetGatewayHealth$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getIotnetGatewayHealth(params: GetIotnetGatewayHealth$Params, context?: HttpContext): Promise<HealthRecord> {
    const resp = this.getIotnetGatewayHealth$Response(params, context);
    return resp.then((r: StrictHttpResponse<HealthRecord>): HealthRecord => r.body);
  }
}
